export default __webpack_public_path__ + "static/media/dots.8b5d2e62.svg";